import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Card, Grid, Icon, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function SoporteTecnico() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6} justifyContent="center">
          {/* Tarjeta de información de contacto - Centrada */}
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Información de Contacto
                </MDTypography>
              </MDBox>
              <MDBox pt={4} px={4} pb={4}>
                <Grid container spacing={3}>
                  {/* Email */}
                  <Grid item xs={12} md={6}>
                    <MDBox display="flex" alignItems="center">
                      <MDBox
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="3rem"
                        height="3rem"
                        borderRadius="md"
                        sx={{ backgroundColor: "info.main" }}
                        mr={2}
                      >
                        <Icon fontSize="medium" sx={{ color: "white" }}>
                          email
                        </Icon>
                      </MDBox>
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium">
                          Email
                        </MDTypography>
                        <MDTypography variant="body2" color="text">
                          equipokoop@gmail.com
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Grid>

                  {/* Teléfono */}
                  <Grid item xs={12} md={6}>
                    <MDBox display="flex" alignItems="center">
                      <MDBox
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="3rem"
                        height="3rem"
                        borderRadius="md"
                        sx={{ backgroundColor: "success.main" }}
                        mr={2}
                      >
                        <Icon fontSize="medium" sx={{ color: "white" }}>
                          phone
                        </Icon>
                      </MDBox>
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium">
                          Teléfono
                        </MDTypography>
                        <MDTypography variant="body2" color="text">
                          +57 3146003484
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Grid>

                  {/* Horario */}
                  <Grid item xs={12} md={6}>
                    <MDBox display="flex" alignItems="center">
                      <MDBox
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="3rem"
                        height="3rem"
                        borderRadius="md"
                        sx={{ backgroundColor: "warning.main" }}
                        mr={2}
                      >
                        <Icon fontSize="medium" sx={{ color: "white" }}>
                          schedule
                        </Icon>
                      </MDBox>
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium">
                          Horario
                        </MDTypography>
                        <MDTypography variant="body2" color="text">
                          Lunes a Viernes: 8:00 AM - 6:00 PM
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Grid>

                  {/* Ubicación */}
                  <Grid item xs={12} md={6}>
                    <MDBox display="flex" alignItems="center">
                      <MDBox
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="3rem"
                        height="3rem"
                        borderRadius="md"
                        sx={{ backgroundColor: "error.main" }}
                        mr={2}
                      >
                        <Icon fontSize="medium" sx={{ color: "white" }}>
                          location_on
                        </Icon>
                      </MDBox>
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium">
                          Ubicación
                        </MDTypography>
                        <MDTypography variant="body2" color="text">
                          Cali, Valle del Cauca, Colombia
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>

          {/* Preguntas Frecuentes */}
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="dark"
                borderRadius="lg"
                coloredShadow="dark"
                display="flex"
                alignItems="center"
              >
                <Icon fontSize="medium" sx={{ color: "white", mr: 1 }}>
                  help_outline
                </Icon>
                <MDTypography variant="h6" color="white">
                  Preguntas Frecuentes
                </MDTypography>
              </MDBox>
              <MDBox pt={3} px={2} pb={3}>
                {/* Pregunta 1 */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <MDBox display="flex" alignItems="center">
                      <Icon sx={{ color: "info.main", mr: 1 }}>person_add</Icon>
                      <MDTypography variant="h6" fontWeight="medium">
                        ¿Cómo puedo agregar más candidatos?
                      </MDTypography>
                    </MDBox>
                  </AccordionSummary>
                  <AccordionDetails>
                    <MDTypography variant="body2" color="text" pl={4}>
                      Dirígete a &ldquo;Gestión de Candidatos&rdquo; → &ldquo;Cargar Candidatos&rdquo; donde podrás
                      agregar candidatos uno por uno o cargando un archivo masivo en formato CSV o Excel.
                      También puedes importar desde tu base de datos existente.
                    </MDTypography>
                  </AccordionDetails>
                </Accordion>

                {/* Pregunta 2 */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <MDBox display="flex" alignItems="center">
                      <Icon sx={{ color: "success.main", mr: 1 }}>shopping_cart</Icon>
                      <MDTypography variant="h6" fontWeight="medium">
                        ¿Cómo compro más licencias?
                      </MDTypography>
                    </MDBox>
                  </AccordionSummary>
                  <AccordionDetails>
                    <MDTypography variant="body2" color="text" pl={4}>
                      Ve a &ldquo;Gestión de Licencias&rdquo; → &ldquo;Comprar licencias&rdquo; y selecciona el paquete
                      que mejor se adapte a tus necesidades. Aceptamos pagos con tarjeta de crédito,
                      débito y transferencias bancarias. Las licencias se activan inmediatamente después del pago.
                    </MDTypography>
                  </AccordionDetails>
                </Accordion>

                {/* Pregunta 3 */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                  >
                    <MDBox display="flex" alignItems="center">
                      <Icon sx={{ color: "warning.main", mr: 1 }}>assignment</Icon>
                      <MDTypography variant="h6" fontWeight="medium">
                        ¿Cómo asigno una licencia a un candidato?
                      </MDTypography>
                    </MDBox>
                  </AccordionSummary>
                  <AccordionDetails>
                    <MDTypography variant="body2" color="text" pl={4}>
                      En la sección &ldquo;Asignar Licencias&rdquo;, selecciona el deseado (Quadrante H),
                      marca los candidatos a los que deseas enviarlo y haz clic en &ldquo;Asignar Licencia&rdquo;.
                      El sistema enviará automáticamente las credenciales por email.
                    </MDTypography>
                  </AccordionDetails>
                </Accordion>

                {/* Pregunta 4 */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4-content"
                    id="panel4-header"
                  >
                    <MDBox display="flex" alignItems="center">
                      <Icon sx={{ color: "error.main", mr: 1 }}>assessment</Icon>
                      <MDTypography variant="h6" fontWeight="medium">
                        ¿Puedo ver los resultados de las evaluaciones?
                      </MDTypography>
                    </MDBox>
                  </AccordionSummary>
                  <AccordionDetails>
                    <MDTypography variant="body2" color="text" pl={4}>
                      Sí, en &ldquo;Gestión de Candidatos&rdquo; → &ldquo;Informes&rdquo; podrás ver todos los resultados
                      detallados, incluyendo gráficas del perfil Quadrante H, interpretación de resultados
                      y recomendaciones. También puedes descargar reportes en PDF para compartir con tu equipo.
                    </MDTypography>
                  </AccordionDetails>
                </Accordion>

                {/* Pregunta 5 */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel5-content"
                    id="panel5-header"
                  >
                    <MDBox display="flex" alignItems="center">
                      <Icon sx={{ color: "info.main", mr: 1 }}>schedule</Icon>
                      <MDTypography variant="h6" fontWeight="medium">
                        ¿Cuánto tiempo tiene el candidato para completar la evaluacion?
                      </MDTypography>
                    </MDBox>
                  </AccordionSummary>
                  <AccordionDetails>
                    <MDTypography variant="body2" color="text" pl={4}>
                      La evaluacion Quadrante H no tiene límite de tiempo. El candidato puede completarlo
                      a su propio ritmo. En promedio, toma entre 15-20 minutos. Las credenciales
                      permanecen activas hasta que el candidato complete la evaluación.
                    </MDTypography>
                  </AccordionDetails>
                </Accordion>

                {/* Pregunta 6 */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel6-content"
                    id="panel6-header"
                  >
                    <MDBox display="flex" alignItems="center">
                      <Icon sx={{ color: "success.main", mr: 1 }}>workspace_premium</Icon>
                      <MDTypography variant="h6" fontWeight="medium">
                        ¿Qué pasa si se me acaban las licencias?
                      </MDTypography>
                    </MDBox>
                  </AccordionSummary>
                  <AccordionDetails>
                    <MDTypography variant="body2" color="text" pl={4}>
                      El sistema te notificará cuando te queden pocas licencias disponibles.
                      Si intentas asignar Licencias y no cuentas con suficientes, se te pedirá que
                      compres más antes de continuar. No te preocupes, tus datos y candidatos
                      permanecen seguros mientras adquieres nuevas licencias.
                    </MDTypography>
                  </AccordionDetails>
                </Accordion>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SoporteTecnico;

